<template>
  <div v-if="value">
    <div class="row">
      <div class="col-lg-4 col-sm-4">
        <base-input
          alternative
          label="CEP"
          placeholder="99.999-999"
          input-classes="form-control-alternative"
          type="tel"
          v-mask="'##.###-###'"
          v-model="value.cep"
        />
      </div>
      <div class="col-lg-8 col-sm-8 col-12">
        <base-input
          alternative
          label="Logradouro"
          placeholder="Rua, Av, Travessia..."
          input-classes="form-control-alternative"
          v-model="value.logradouro"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3 col-6">
        <base-input
          alternative
          label="Número"
          placeholder="999A"
          input-classes="form-control-alternative"
          v-model="value.numero"
        />
      </div>
      <div class="col-sm-3 col-6">
        <base-input
          alternative
          label="Complemento"
          placeholder="AP/Bloco"
          input-classes="form-control-alternative"
          v-model="value.complemento"
        />
      </div>
      <div class="col-sm-6 col-12">
        <base-input
          alternative
          label="Bairro"
          placeholder="Bairro"
          input-classes="form-control-alternative"
          v-model="value.bairro"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <base-input
          alternative
          label="Cidade"
          placeholder="Cidade"
          input-classes="form-control-alternative"
          v-model="value.cidade"
        />
      </div>
      <div class="col-4">
        <base-input
          alternative
          label="Estado"
          v-model="value.estado"
        >
          <select
            class="form-control form-control-alternative"
            v-model="value.estado"
          >
            <option value="">Selecione</option>
            <option v-for="estado in estados" :key="estado" :value="estado">{{ estado }}</option>
          </select>
        </base-input>
      </div>
    </div>
  </div>
</template>
<script>
const estados = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SE", "SC", "SP", "TO"];
export default {
  props: {
    value: Object
  },
  watch: {
    value: {
      handler(novo) {
        this.$emit('input', novo);
      },
      deep: true,
    },
  },
  data() {
    return {
      estados,
    }
  }
}
</script>